import { render } from '@wordpress/element';
import App from './components/App';
import './style.css';

const rootElement = document.getElementById('wppub-settings');
if (rootElement) {
    render(<App />, rootElement);
}
